<template>
    <b-overlay :show="busy" rounded="sm">
        <!-- {{ search }}<br /><br />
          {{ item }} -->
        <b-card class="standardpage reports invoices border-none">
            <!-- <b-card-header class="py-1 mb-2">
              <i :class="options.icon" class="text-primary mr-1"></i>
              {{ item.slac }}
              <span class="text-warning"
                >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
              >
            </b-card-header> -->
            <div class="availtable datatable text-left">
                <b-card-body class="py-0">
                    <b-tabs class="gridtabs">
                        <b-tab :active="true">
                            <template #title>
                                <div class="badgecontainer pr-5">
                                    <i :class="carbonsegments.icon" class="text-primary mr-1"></i>
                                    <span class="text-center badgenormal badge-secondary badge-pill">
                                        {{ item.startcity }} - {{ item.endcity }}
                                    </span>
                                    <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
                                </div>
                            </template>
                            <p class="py-3 px-0">
                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Type" label-for="type" label-cols="12" label-size="sm">
                                            <treeselect v-model="item.type" :clearable="true" :options="options_type"
                                                :disabled="false"></treeselect>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Start City" label-size="sm">
                                            <treeselect placeholder="Select city..."
                                                searchPromptText="Type at least 3 chars..." v-model="item.startcity"
                                                :disabled="readonly" :clearable="true" :async="true"
                                                :load-options="treeselect_loadIATA" :show-count="true"
                                                :flatten-search-results="true" :disable-branch-nodes="true"
                                                :matchKeys="['id']" search-nested>
                                                <div slot="value-label" slot-scope="{ node }">
                                                    {{ node.raw.id }}
                                                </div>
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="End City" label-size="sm">
                                            <treeselect placeholder="Select city..."
                                                searchPromptText="Type at least 3 chars..." v-model="item.endcity"
                                                :disabled="readonly" :clearable="true" :async="true"
                                                :load-options="treeselect_loadIATA" :show-count="true"
                                                :flatten-search-results="true" :disable-branch-nodes="true"
                                                :matchKeys="['id']" search-nested>
                                                <div slot="value-label" slot-scope="{ node }">
                                                    {{ node.raw.id }}
                                                </div>
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Equipment" label-size="sm">
                                            <treeselect placeholder="Select equipment..."
                                                searchPromptText="Type at least 3 chars..." v-model="item.equipment"
                                                :disabled="readonly" :clearable="true" :async="true"
                                                :load-options="treeselect_loadAircraft" :show-count="true"
                                                :flatten-search-results="true" :disable-branch-nodes="true"
                                                :matchKeys="['id']" search-nested>
                                                <div slot="value-label" slot-scope="{ node }">
                                                    {{ node.raw.id }}
                                                </div>
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Class" label-for="cabin" label-cols="12" label-size="sm">
                                            <treeselect v-model="item.cabin" :clearable="true" :options="options_cabin"
                                                :disabled="false"></treeselect>
                                        </b-form-group>
                                    </b-col>


                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Distance" label-for="distance" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.distance"
                                                    placeholder="Enter distance" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.distance = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                      <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Duration" label-for="duration" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.duration"
                                                    placeholder="Enter duration" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.duration = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Adjusted" label-for="adjusted" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.adjusted"
                                                    placeholder="Enter adjusted" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.adjusted = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Location" label-for="location" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.location"
                                                    placeholder="Enter location" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.location = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Nights" label-for="nights" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.nights" placeholder="Enter nights"
                                                    size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.nights = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Rooms" label-for="rooms" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.rooms" placeholder="Enter rooms"
                                                    size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.rooms = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Emission" label-for="emission" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.emission"
                                                    placeholder="Enter emission" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.emission = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Methodology" label-for="methodology" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.methodology"
                                                    placeholder="Enter methodology" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.methodology = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Url" label-for="url" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.url" placeholder="Enter url"
                                                    size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="item.url = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col> -->
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Source" label-for="source" label-cols="12" label-size="sm">
                                            <treeselect v-model="item.source" :clearable="true" :options="options_source"
                                                :disabled="false"></treeselect>
                                        </b-form-group>
                                    </b-col>

                                </b-row>
                                <b-row>
                                    <b-col cols="12" sm="12">
                                        <b-form-group label="Notes" label-for="notes" label-cols="12">
                                            <b-form-textarea id="message" rows="8" v-model="item.notes"
                                                placeholder="Notes"></b-form-textarea>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                            </p>
                        </b-tab>
                        <b-tab v-if="idselected">
                            <template #title>
                                <i class="fa fa-history text-primary mr-1"></i> Audit
                            </template>
                            <p class="py-3 px-0">
                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                            <b-input-group>
                                                <b-input-group-prepend>
                                                    <b-form-datepicker size="sm" v-model="item.created_at" button-only
                                                        label-help="" locale="en-GB" :disabled="true"></b-form-datepicker>
                                                </b-input-group-prepend>
                                                <b-form-input size="sm" id="date" v-model="item.created_at" type="text"
                                                    placeholder="YYYY-MM-DD" autocomplete="off"
                                                    :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.created_at = null" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                                                    :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.created_by = ''" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                            <b-input-group>
                                                <b-input-group-prepend>
                                                    <b-form-datepicker size="sm" v-model="item.updated_at" button-only
                                                        label-help="" locale="en-GB" :disabled="true"></b-form-datepicker>
                                                </b-input-group-prepend>
                                                <b-form-input size="sm" id="date" v-model="item.updated_at" type="text"
                                                    placeholder="YYYY-MM-DD" autocomplete="off"
                                                    :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.updated_at = null" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                                                    :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.updated_by = ''" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="ID" label-for="id" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.id" placeholder="" size="sm"
                                                    :disabled="true"></b-form-input>

                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Refresh?" label-for="refresh" label-cols="12">
                                            <!-- :checked="item.refresh==true?true:false" -->
                                            <b-form-radio-group id="refresh" v-model="item.refresh" 
                                                :options="[
                                                    { text: 'No', value: false },
                                                    { text: 'Yes', value: true },
                                                ]" buttons button-variant="outline-success" size="sm"
                                                name="radio-btn-outline"></b-form-radio-group> </b-form-group></b-col>
                                </b-row>
                            </p>
                            <!-- {{ item }} -->
                        </b-tab></b-tabs>
                </b-card-body>
                <b-card-footer class="mt-2 ml-1">
                    <b-row no-gutters>
                        <b-col cols="auto" class="text-left">
                            <b-button squared size="sm" variant="primary" @click="saveit()" :disabled="postit_disabled">
                                <i class="fa fa-check"></i>
                                Save It
                            </b-button>
                        </b-col>
                        <b-col class="text-left ml-2 mt-1">
                            <div v-if="busy">
                                <i class="fa fa-spinner fa-spin text-primary"></i>
                            </div>
                            <div v-else>
                                <span v-html="message"></span>
                            </div>
                        </b-col>
                        <b-col class="text-right" cols="8">
                            <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
                                <i class="fa fa-chevron-left pr-1"></i>
                                Back
                            </b-button>
                        </b-col>
                    </b-row>

                </b-card-footer>
            </div>
            <!-- {{ snapshot }} -->
        </b-card>
    </b-overlay>
</template>
      
<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

export default {
    name: "CarbonSegmentEdit",
    props: {
        snapshot: { type: String, default: null },
    },
    data() {
        return {
            busy: false,
            readonly: false,
            postit_disabled: false,
            options_type: [
                { id: "AIR", label: "Air" },
                { id: "HTL", label: "Hotel" },
                { id: "CAR", label: "Car" },
                { id: "RAI", label: "Rail" },
                { id: "XFR", label: "Transfer" },
                { id: "SEA", label: "Ferry" },
            ],
            options_cabin: [
                { id: "economy", label: "ECONOMY" },
                { id: "premium", label: "PREMIUM" },
                { id: "business", label: "BUSINESS" },
                { id: "first", label: "FIRST" },

            ],
            options_source: [
                { id: "thrust", label: "THRUST" },
                { id: "icao", label: "ICAO" },

            ],
            item: {
                id: null,
                type: "AIR",
                equipment: null,
                cabin: "economy",
                startcity: null,
                endcity: null,
                distance: "<api pending>",
                duration: null,
                adjusted: null,
                location: null,
                nights: null,
                rooms: null,
                methodology: null,
                emission: "<api pending>",
                source: null,
                refresh: true,
                notes: null,
            },
            carbonsegments: {
                title: "Client Emissions",
                icon: "fa fa-globe",


            },
        };
    },
    watch: {
        selection() {
            this.load();
        },
    },

    methods: {
        async load() {
            let variables = {
                id: this.selection[0].id,
                snapshot: this.snapshot ? this.snapshot : 'live_finance',
                // dateformat: "YYYY-MM-DD",
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
              query carbonsegments($id: String, $snapshot: String) {
                carbonsegments(id: $id, snapshot: $snapshot) {
                  id
                  type
                  equipment
                  cabin
                  startcity  
                  endcity 
                  distance
                  duration
                  adjusted
                  location
                  nights
                  rooms
                  methodology
                  emission
                  source
                  refresh
                  notes
                  updated_at
                  updated_by
                  created_at
                  created_by
                  rows
                }
              }
            `,
                    variables,
                });

                this.item = response.data.carbonsegments[0];

            } catch (error) {
                console.log(error);
            }
            this.busy = false;
        },
        async saveit() {

            this.busy = true;

            let variables = { rows: [this.cleanit(this.item)], snapshot: this.snapshot };
            console.log("variables", variables);
            // delete variables.rows[0].startdate;
            // delete variables.rows[0].enddate;

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation carbonsegments_save(
                            $rows: [Carbonsegment_input]
                            $snapshot: String
                        ) {
                            carbonsegments_save(rows: $rows, snapshot: $snapshot) {
                            id
                            }
                        }
                        `,
                    variables,
                });
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },

    },
};
</script>
      
<style></style>